import { render } from "./vworkorderlistinfo.vue?vue&type=template&id=664a8bb0&scoped=true"
import script from "./vworkorderlistinfo.vue?vue&type=script&lang=js"
export * from "./vworkorderlistinfo.vue?vue&type=script&lang=js"

import "./vworkorderlistinfo.vue?vue&type=style&index=0&id=664a8bb0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664a8bb0"]])

export default __exports__